import { render, staticRenderFns } from "./MainBookIndex.vue?vue&type=template&id=1d21d46b&scoped=true"
import script from "./MainBookIndex.vue?vue&type=script&lang=js"
export * from "./MainBookIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21d46b",
  null
  
)

export default component.exports